import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/terms.scss";

function Terms() {
  useEffect(() => {
    document.title = `Terms of use | ${siteConfig.displayName}`;
  }, []);

  return (
    <main className="policy-page terms-page">
      <nav className="legal-tabs" aria-label="Legal information">
        <Link to="/privacy">Privacy policy</Link>
        <Link className="is-active" to="/terms">Terms of use</Link>
        <Link to="/cookies">Cookie policy</Link>
        <Link to="/faqs">FAQs</Link>
      </nav>
      <header className="policy-heading">
        <p className="eyebrow">LEGAL</p>
        <h1>Terms of use</h1>
        <p>Last modified: September 16, 2026</p>
      </header>
      <div className="policy-columns">
        <section>
          <h2>1. About this storefront</h2>
          <p>
            These terms govern access to {siteConfig.website.replace("https://", "")},
            operated by {siteConfig.companyName}. By using the storefront or placing
            an order, you agree to these terms.
          </p>
          <h2>2. Product information</h2>
          <p>
            We work to present colors, descriptions and availability clearly.
            Screens and lighting can affect how a color appears, and production
            availability would be confirmed when a real order is accepted.
          </p>
          <h2>3. Prices and payment</h2>
          <p>
            Displayed prices are in US dollars. Taxes and delivery are summarized
            before payment. An order is accepted when we send an order confirmation.
          </p>
        </section>
        <section>
          <h2>4. Intellectual property</h2>
          <p>
            The interface, original photography and written content on this site
            may not be republished as another brand's commercial identity without
            permission. Third-party marks are not granted or implied.
          </p>
          <h2>5. Acceptable use</h2>
          <p>
            Do not disrupt the site, attempt unauthorized access, upload malicious
            code or use automated means that place unreasonable demand on the
            service. We may restrict access to protect users and the platform.
          </p>
          <h2>6. Questions</h2>
          <p>
            Contact <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a> for
            questions about these terms or your order.
          </p>
        </section>
      </div>
    </main>
  );
}

export default Terms;
